import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DesignedToPerform from "./sections/DesignedToPerform";
import CoreTechnicalCapabilities from "./sections/CoreTechnicalCapabilities";
import CommitmentToGistmIcmmExcellence from "./sections/CommitmentToGistmIcmmExcellence";
import IndustryPortfolio from "./sections/IndustryPortfolio";
import EngineeringSustainableFutures from "./sections/EngineeringSustainableFutures";
import ProfessionalCollaboration from "./sections/ProfessionalCollaboration";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DesignedToPerform />
      <CoreTechnicalCapabilities />
      <CommitmentToGistmIcmmExcellence />
      <IndustryPortfolio />
      <EngineeringSustainableFutures />
      <ProfessionalCollaboration />
      <Footer />
    </div>;
}